export const SEEN_TAB_EDUCATION_MODAL = 'SEEN_TAB_EDUCATION_MODAL';
